<template>
  <div style="margin-top: 2%;">
    <van-tabs v-model="selectTab" class="selectTab" @click="tabSelected">
      <van-tab title="待处理" name="202111300001">
      </van-tab>
      <van-tab title="申诉成功" name="202111300003">
      </van-tab>
      <van-tab title="申诉失败" name="202111300002">
      </van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell v-for="item in dataList" :key="item.id" :title="item.title" :label="item.label">
          <template #title>
            <span style="font-size: x-small;">订单编号：<span>{{item.orderNumbers}}</span></span>
            <span style="font-size: x-small;margin-left: 5%;">
              {{item.appealTypeStr}}
            </span>
          </template>
          <template #default>
            <span style="font-size:xx-small;color: #44b1eb">{{item.createTime}}</span>
          </template>
          <template #label>
            结果：<span style="color: red;font-size: x-small;">{{item.appealSaies}}</span>
          </template>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {queryAppealList} from "../../api/system/mobile_taskorder";
import {MessageBox} from "mint-ui";

export default {
name: "AppealCenter",
  data(){
  return {
    selectTab:0,
    loading: false,
    finished: false,
    refreshing: false,
    queryForm:{},
    dataList:[
    ],
    pagination:{
      pageNum: 1,
      pageSize: 20,
      total: null
    },
  }
  },
  mounted() {
    this.$emit("titleChange", "申诉中心");
    this.queryForm.appealStatus = "202111300001";
    this.pagination.pageNum = 1;
    this.getData();
  },
  methods:{
    tabSelected(name, title){
      console.log(name, title);
      this.queryForm.appealStatus = name;
      this.pagination.pageNum = 1;
      this.getData();
    },
    onLoad() {
      if (this.refreshing) {
        this.refreshing = false;
      }
      if (!this.finished) {
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      queryAppealList(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          console.log(res.data)
          if (res.data.records.length > 0) {
            this.dataList.push(...res.data.records);
          }
          this.loading = false;
          this.finished = true;
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    getData(){
      queryAppealList(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          console.log(res.data)
          this.dataList = res.data.records;
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  }
}
</script>

<style scoped>

</style>
